import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regStar } from '@fortawesome/free-regular-svg-icons';

function SmallReportItem({
  report, inFavorites, onToggleFavorites,
}) {
  return (
    <Card className="my-2 h-100 d-flex flex-column">
      <Card.Body className="d-flex flex-column flex-grow-1">
        <div className="d-flex gap-1 align-items-start">
          <Card.Title className="fs--1 fw-bold flex-fill">
            <Link to={`/rep/${report.identifier}/${report.id}`} className="text-dark">
              {report.name}
            </Link>
          </Card.Title>
          <button type="button" className="btn btn-link p-0" title="Додати в улюблені" onClick={() => onToggleFavorites(report.id)}>
            <span className="sr-only">Додати в улюблені</span>
            <FontAwesomeIcon icon={inFavorites ? solidStar : regStar} className="text-warning" />
          </button>
        </div>
        <Card.Text className="fst-italic flex-fill">
          {report.description}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export const reportPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  repr: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  updated: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  avatarImg: PropTypes.string,
});

SmallReportItem.propTypes = {
  report: reportPropType.isRequired,
  inFavorites: PropTypes.bool,
  onToggleFavorites: PropTypes.func.isRequired,
};

SmallReportItem.defaultProps = {
  inFavorites: false,
};

export default SmallReportItem;
